import {CrmLayoutBar} from "../../../LayoutCrm";
import React, {Component} from "react";
import {SubmitButton} from "../../buttons/SubmitButton";
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {LocalStorage} from "../../../utils/LocalStorage";
import {withRouterParams} from "../../../utils/withRouterParams";
import { withTranslation } from "react-i18next";

class ConfigPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            emails: ''
        };

        this.handleEmailsChange = this.handleEmailsChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    // URLS

    crmApiURL() {
        return `${API_URL}${this.crmApiPath()}`;
    }

    crmApiPath() {
        let clientId;
        if (LocalStorage.hasUserClientId()) {
            clientId = LocalStorage.fetchUserClientId();
        } else {
            clientId = this.props.match.params.clientId;
        }
        return `crm/${clientId}`;
    }

    crmFrontPath() {
        let clientId;
        if (this.props.match.params.hasOwnProperty('clientId')) {
            clientId = this.props.match.params.clientId;
            return `crm/${clientId}`;
        } else {
            return `crm`;
        }
    }

    componentDidMount() {
        this.getClientContactEmails();
    }

    crmConfigURL() {
        return `${this.crmApiURL()}/config`
    }

    getClientContactEmails() {
        new APIClient(this.crmConfigURL()).call('GET').then(response => {
            if (response.status === 'OK') {
                this.setState({
                    emails: response.data.contact_emails.join(', ')
                })
            } else {
                alert(response['error_message'])
            }
        });
    }

    handleEmailsChange(event) {
        this.setState({
            emails: event.target.value
        })
    }

    handleSubmit() {
        const { t } = this.props;
        const emails = this.state.emails.split(", ");
        new APIClient(this.crmConfigURL()).call('PUT', {emails: emails}).then((response) => {
            if (response.status === 'OK') {
                alert(t('crm_config.changes_saved_successfully'))
            } else {
                alert(response['error_message'])
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="crm-content">
                <CrmLayoutBar crmFrontPath={this.crmFrontPath()}/>
                <section className="crm-section-content">
                    <header className="crm-section-header">
                        <h1 className="section-title">{t('crm_config.title')}</h1>
                    </header>
                    <form className="config-form">
                        <div className="form-row">
                            <label>{t('crm_config.send_leads_to')}</label>
                            <p className="input-description">{t('crm_config.multiple_emails_help')}</p>
                            <input type='text' onChange={this.handleEmailsChange} value={this.state.emails}
                                   className="emails"/>
                        </div>
                        <div className="submit-row">
                            <SubmitButton onClick={this.handleSubmit} value={t('save_button')}/>
                        </div>
                    </form>
                </section>
            </div>
        )
    }
}

export default withRouterParams(withTranslation()(ConfigPage));